import React from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { isRtlLanguage } from "../utils/rtl";

const ErrorMessage = (props) => {
	const { t } = useTranslation();
	const { language } = useI18next();
	const isRtl = isRtlLanguage(language);

	return (
		<div className="w-full max-w-sm border rounded-md h-12 text-sm flex items-center">
			<div className={`bg-red h-full w-2 justify-self-center ${isRtl ? "rounded-r-md" : "rounded-l-md"}`}></div>
			<p className={`${isRtl ? "mr-3" : "ml-3"} text-gray`}>
				<span className="text-red uppercase font-bold">
					{t("error_label") /* Translate "VIGA:" */}
				</span>{" "}
				{props.error}
			</p>
		</div>
	);
};

export default ErrorMessage;
